import React, {useEffect, useState} from 'react';
import { Snackbar, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {scale} from "../../utils";
import theme, {FONTS} from "../../constants/theme";
import ThemedText from "../text";

interface Props {
  show: boolean;
}

const Notify = ({show}: Props) => {
  const [open, setOpen] = useState(show);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (open) {
      setProgress(0);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + (100 / (5000 / 100));
        });
      }, 100);
    }

    return () => setProgress(0);
  }, [open]);

  const closeSnackbar = () => setOpen(false);

  return (
      <Snackbar
        open={open}
        onClose={closeSnackbar}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          top: scale(234).concat(' !important'),
          width: scale(350),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#FFFFFF',
            color: '#333',
            borderRadius: '4px',
            border: '1px solid #ddd',
            padding: '8px 16px',
            boxShadow: 3,
            width: '100%',
            height: scale(60),
            maxWidth: 300,
            justifyContent: 'flex-start',
            position: 'relative',
          }}
        >
          <CheckCircleIcon color={'green'} sx={{ mr: 1 }} />
          <ThemedText
            text={'RACCOLTA CREATA'}
            color={theme.palette.ceramic.contrastText}
            fontWeight={700}
            fontSize={scale(14)}
            fontFamily={FONTS.MONTSERRAT}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              height: scale(8),
              width: '100%',
              background: 'linear-gradient(to right, #a8d5a8 100%, #69c069 100%)',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: '100%',
                width: `${progress}%`,
                backgroundColor: '#69c069',
                transition: 'width 0.1s ease',
              }}
            />
          </Box>
        </Box>
      </Snackbar>
  );
};

export default Notify;
